import React from "react";
import { Form } from "react-bootstrap";
import CamplaCoreService from "../../../../services/CamplaCoreService";
import ValidationHelper from "../../../../helpers/ValidationHelper";
import { withTranslation } from "react-i18next";
import BaseDialog from "../../../../components/dialogs/baseDialog/BaseDialog";
import MarkDownEditor from "../../../../components/markdownEditor/MarkDownEditor";
import BaseSelect from "../../../../components/baseSelect/BaseSelect";

class ModuleDialog extends React.Component {
  constructor(props) {
    super(props);

    this.validationDefinition = {
      abbreviation: {
        defaultValue: "",
        rule: ValidationHelper.isString
      },
      name: {
        defaultValue: "",
        rule: ValidationHelper.isString
      },
      department: {
        defaultValue: "",
        rule: ValidationHelper.isStringArray
      },
      description: {
        defaultValue: {de: "", en: "", fr: "", it: ""},
        initValid: true,
        rule: ValidationHelper.isExtendedDescription
      },
    };

    this.state = {
      departments: [],
      validation: ValidationHelper.getValidation(this.validationDefinition)
    };

    this.handleChange = this.handleChange.bind(this);
    this.onSubmit = this.onSubmit.bind(this);
    this.onHide = this.onHide.bind(this);
  }

  handleChange(event) {
    this.setState({
      validation: ValidationHelper.update(event, this.state.validation)
    });
  }

  componentDidUpdate(prevProps) {
    //TODO: Support other languages
    const lang = this.props.i18n.language.toLowerCase().split("-")[0];
    if (this.props.show && this.props.show !== prevProps.show){
      const departments = this.props.departments.map(dep => {
        return {
          label: dep.description[lang],
          value: dep._id
        }
      });
      this.setState({departments});
    }
    if (this.props.show && this.props.show !== prevProps.show && this.props.module) {
      const val = ValidationHelper.getValidation(
        {
          name: {
            defaultValue: this.props.module.name || "",
            rule: ValidationHelper.isString
          },
          abbreviation: {
            defaultValue: this.props.module.abbreviation || "",
            rule: ValidationHelper.isString
          },
          department: {
            defaultValue: this.props.module.department || "",
            rule: ValidationHelper.isStringArray
          },
          description: {
            defaultValue: this.props.module.description || {de: "", en: "", fr: "", it: ""},
            rule: ValidationHelper.isExtendedDescription
          }
        },
        true
      );
      this.setState({
        validation: val
      });
    } else if (!this.props.show && this.props.show !== prevProps.show) {
      this.setState({
        validation: ValidationHelper.getValidation(
          this.validationDefinition,
          true
        )
      });
    }
  }
  onHide() {
    this.props.onHide(ValidationHelper.hasChanged(this.state.validation));
  }

  onSubmit() {
    if (this.state.validation._isValid) {
      const validatedData = ValidationHelper.getData(this.state.validation);
      validatedData["userId"] = CamplaCoreService.getAuthenticatedUser()._id;
      this.props.onSubmit(validatedData);
    }
  }

  render() {
    const { t } = this.props;
    return (
      <BaseDialog
        show={this.props.show}
        onHide={this.onHide}
        rightButtonCallback={this.onSubmit}
        title={this.props.title}
        rightButtonText={this.props.submitText}
        leftButtonText={t("DialogCancel")}
        rightButtonVariant="green"
        leftButtonVariant="black"
        leftButtonCallback={this.onHide}
        dialogApiError={this.props.dialogApiError}
        rightButtonDisabled={!this.state.validation._isValid}
        body={(<Form onSubmit={this.onSubmit}>
          <Form.Group controlId="formAbbrev">
            <Form.Label>
              {t("Modules.ModuleDialog.Form.Abbreviation")}
            </Form.Label>
            <Form.Control
              type="text"
              name="abbreviation"
              placeholder={t(
                "Modules.ModuleDialog.Form.AbbreviationPlaceholder"
              )}
              value={this.state.validation.abbreviation.value}
              isInvalid={!this.state.validation.abbreviation.isValid}
              onChange={this.handleChange}
            />
            <Form.Control.Feedback type="invalid">
              {t("Modules.ModuleDialog.ValidationError.Abbreviation")}
            </Form.Control.Feedback>
          </Form.Group>
          <Form.Group controlId="formModuleName">
            <Form.Label>
              {t("Modules.ModuleDialog.Form.Name")}
            </Form.Label>
            <Form.Control
              type="text"
              name="name"
              placeholder={t(
                "Modules.ModuleDialog.Form.NamePlaceholder"
              )}
              value={this.state.validation.name.value}
              isInvalid={!this.state.validation.name.isValid}
              onChange={this.handleChange}
            />
            <Form.Control.Feedback type="invalid">
              {t("Modules.ModuleDialog.ValidationError.Name")}
            </Form.Control.Feedback>
          </Form.Group>
          <Form.Group controlId="formBasicSemester">
            <Form.Label>
              {t("Modules.ModuleDialog.Form.Department")}
            </Form.Label>
            <BaseSelect
                isSearchable={false}
                isMulti={true}
                options={this.state.departments}
                onChange={selected => {
                  this.handleChange({
                    target: {
                      name: "department",
                      value: selected ? selected.map(i => i.value) : []
                    }
                  });
                }}
                value={this.state.departments.filter(dep => this.state.validation.department.value.indexOf(dep.value) > -1)}
                placeholder={t(
                    "Modules.ModuleDialog.Form.DepartmentPlaceholder"
                )}
            />
            <Form.Control
                type="hidden"
                isInvalid={!this.state.validation.department.isValid}
            />
            <Form.Control.Feedback type="invalid">
              {t("Modules.ModuleDialog.ValidationError.Department")}
            </Form.Control.Feedback>
          </Form.Group>
          <MarkDownEditor
            defaultValue={this.props.module ? this.props.module.description
                : ValidationHelper.getDefaultValueExtendedDescription()}
            onChange={value =>
              this.handleChange({
                target: {
                  name: "description",
                  value: value
                }
              })
            }

          />
        </Form>)}
      />
    );
  }
}

export default withTranslation()(ModuleDialog);
